import ConfirmDeleteRecipeModalComponent from "./ConfirmDeleteRecipeModalComponent";

export default ConfirmDeleteRecipeModalComponent;